angular
    .module("skillBuilderSaaS")
    .directive("ngAriaBusy", function () {
    return {
        restrict: "A",
        link: function (scope, element, attr) {
            scope.$watch(attr.ngAriaBusy, function (value) {
                element.attr("aria-busy", value);
            });
        }
    };
});
